import { getBrowserClientData } from './browserData';

export const functionCollectBrowserData = async () => {
  let browserData: any = null;
  try {
    browserData = await getBrowserClientData();
  } catch (error) {
    console.log(error, 'error while collecting browser information');
  }

  return browserData;
};

